import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.constructor";
import _typeof from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
import "core-js/modules/es6.regexp.replace";

/**
 * 当前日期
 * @returns {Date}
 */
export function now() {
  return now;
}
;
/**
 * 当前日
 * @returns {number}
 */

export function nowDay() {
  return new Date().getDate();
}
;
/**
 * 今天本周的第几天
 * @returns {number}
 */

export function nowDayOfWeek() {
  return new Date().getDay();
}
;
/**
 * 当前月
 * @returns {number}
 */

export function nowMonth() {
  return new Date().getMonth();
}
;
/**
 * 当前年
 * @returns {*}
 */

export function nowYear() {
  var nowYear = now.getFullYear();
  nowYear += nowYear < 2000 ? 1900 : 0;
  return nowYear;
}
;
export function preMonth() {
  var lastMonthDate = new Date(); //上月日期

  lastMonthDate.setDate(1);
  lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
  return lastMonthDate.getMonth();
}
;
export function preYear() {
  var lastMonthDate = new Date(); //上月日期

  lastMonthDate.setDate(1);
  lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
  return lastMonthDate.getFullYear();
}
;
export function getNewDate(date) {
  if (date == null || date == "") {
    date = new Date();
  }

  if (typeof date === 'string') {
    date = new Date(date.replace(/-/g, '/').replace(/T|Z/g, ' ').trim());
  } else if (_typeof(date) === 'object') {
    date = new Date(date);
  }

  return date;
}
;
/**
 * 获得几月
 * @param date
 * @returns {string}
 */

export function getMonthDay(value) {
  var a = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二"];
  var d = new Date(value);
  var month = d.getMonth();
  var c = a[month];
  return c;
}
;
/**
 *
 * @param date
 * @returns {string}
 */

export function getWeek(date) {
  var a = ["日", "一", "二", "三", "四", "五", "六"];
  var b = getNewDate(date);
  var week = b.getDay();
  var c = a[week];
  return c;
}
;
/**
 * 格式化日期
 * 兼容ie ios 日期nan问题
 *
 * @param date
 * @param fmt 默认格式为 yyyy-MM-dd
 * @return {*}
 */

export function formatDate(date, fmt) {
  if (date == null || date == '') return null;
  date = getNewDate(date);
  fmt = fmt ? fmt : 'yyyy-MM-dd';

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }

  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };

  for (var k in o) {
    if (new RegExp("(".concat(k, ")")).test(fmt)) {
      var str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }

  return fmt;
}
;
export function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}
;
/**
 * 日期增加/减少天数
 * @param date
 * @param days
 * @return {string}
 */

export function addDateDay(date, days) {
  if (date == null || date == '') {
    return null;
  }

  var d = this.getNewDate(date);
  d.setDate(d.getDate() + days);
  var m = d.getMonth() + 1;
  return d.getFullYear() + '-' + m + '-' + d.getDate();
}
;
/**
 * 日期增加/减少 年份
 * @param date
 * @param days
 * @return {string}
 */

export function addDateYear(date, year) {
  if (date == null || date == '') {
    return null;
  }

  var d = this.getNewDate(date);
  d.setFullYear(d.getFullYear() + year);
  return d;
}
;
/**
 * 返回两个日期之间相差的天数
 * @param day1
 * @param day2
 * @return {number}
 */

export function dateDifferDay(day1, day2) {
  day1 = new Date(formatDate(day1, 'yyyy-MM-dd'));
  day2 = new Date(formatDate(day2, 'yyyy-MM-dd')); // var  startDate = Date.parse(day1);
  // var  endDate = Date.parse(day2);

  var days = (day2 - day1) / (1000 * 60 * 60 * 24);
  return days;
}
;
/**
 * 防止浮点计算bug
 * 加
 * @param a
 * @param b
 */

export function add(a, b) {
  a = a = a == null ? 0 : a;
  b = b = b == null ? 0 : b;
  var c, d, e;

  try {
    c = a.toString().split(".")[1].length;
  } catch (f) {
    c = 0;
  }

  try {
    d = b.toString().split(".")[1].length;
  } catch (f) {
    d = 0;
  }

  return e = Math.pow(10, Math.max(c, d)), (mul(a, e) + mul(b, e)) / e;
}
;
/**
 * 比较两个日期大小
 * @param date1
 * @param date2
 */

export function tab(date1, date2) {
  var oDate1 = new Date(date1);
  var oDate2 = new Date(date2);

  if (oDate1.getTime() > oDate2.getTime()) {
    return false;
  } else {
    return true;
  }
}
/**
 * 防止浮点计算bug
 * 减
 * @param a
 * @param b
 */

export function sub(a, b) {
  a = a == null ? 0 : a;
  b = b == null ? 0 : b;
  var c, d, e;

  try {
    c = a.toString().split(".")[1].length;
  } catch (f) {
    c = 0;
  }

  try {
    d = b.toString().split(".")[1].length;
  } catch (f) {
    d = 0;
  }

  return e = Math.pow(10, Math.max(c, d)), (mul(a, e) - mul(b, e)) / e;
}
;
/**
 * 防止浮点计算bug
 * 乘
 * @param a
 * @param b
 */

export function mul(a, b) {
  a = a == null ? 0 : a;
  b = b == null ? 0 : b;
  var c = 0,
      d = a.toString(),
      e = b.toString();

  try {
    c += d.split(".")[1].length;
  } catch (f) {}

  try {
    c += e.split(".")[1].length;
  } catch (f) {}

  return Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c);
}
;
/**
 * 防止浮点计算bug
 * 除
 * @param a
 * @param b
 */

export function div(a, b) {
  a = a == null ? 0 : a;
  b = b == null ? 0 : b;
  var c,
      d,
      e = 0,
      f = 0;

  try {
    e = a.toString().split(".")[1].length;
  } catch (g) {}

  try {
    f = b.toString().split(".")[1].length;
  } catch (g) {}

  c = Number(a.toString().replace(".", ""));
  d = Number(b.toString().replace(".", ""));
  return JSRound6Bit(mul(c / d, Math.pow(10, f - e)));
}
; //四舍五入,默认保留2位

function JSRound6Bit(fNum) {
  return JSRound(fNum, 2);
} //四舍五入


function JSRound(fNum, fBit) {
  var i = 1,
      m = 1;

  for (i = 1; i <= fBit; i++) {
    m = m * 10;
  }

  return Math.round(fNum * m) / m;
}
/**
 * 数字转大写金额
 * @param num
 * @return {string}
 */


export function numCaseConversion(num, isWithDw) {
  //if (!/^\d*(\.\d*)?$/.test(num)) { alert("Number is wrong!"); return "Number is wrong!"; }
  var AA = new Array("零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖");
  var BB = new Array("", "拾", "佰", "仟", "万", "億", "点", "");
  var a = ("" + num).replace(/(^0*)/g, "").split("."),
      k = 0,
      re = "";

  for (var i = a[0].length - 1; i >= 0; i--) {
    switch (k) {
      case 0:
        re = BB[7] + re;
        break;

      case 4:
        if (!new RegExp("0{4}\\d{" + (a[0].length - i - 1) + "}$").test(a[0])) re = BB[4] + re;
        break;

      case 8:
        re = BB[5] + re;
        BB[7] = BB[5];
        k = 0;
        break;
    }

    if (k % 4 == 2 && a[0].charAt(i + 2) != 0 && a[0].charAt(i + 1) == 0) re = AA[0] + re;
    if (a[0].charAt(i) != 0) re = AA[a[0].charAt(i)] + BB[k % 4] + re;
    k++;
  }

  if (a.length > 1) //加上小数部分(如果有小数部分)
    {
      re += BB[6];

      for (var i = 0; i < a[1].length; i++) {
        re += AA[a[1].charAt(i)];
      }
    } else {
    if (isWithDw == null || isWithDw) {
      re += "元整";
    }
  }

  return re;
}
;
/**
 * 获得月份的天数
 * @param myMonth 月份
 * @return {number} 天数
 */

export function getMonthDays(myMonth) {
  var monthStartDate = new Date(this.nowYear(), myMonth, 1);
  var monthEndDate = new Date(this.nowYear(), myMonth + 1, 1);
  var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
  return days;
}
;
/**
 * 获得本季度的开始月份
 * @return {number} 月份
 */

export function getQuarterStartMonth() {
  var quarterStartMonth = 0;

  if (this.nowMonth() < 3) {
    quarterStartMonth = 0;
  }

  if (2 < this.nowMonth() && this.nowMonth() < 6) {
    quarterStartMonth = 3;
  }

  if (5 < this.nowMonth() && this.nowMonth() < 9) {
    quarterStartMonth = 6;
  }

  if (this.nowMonth() > 8) {
    quarterStartMonth = 9;
  }

  return quarterStartMonth;
}
;
/**
 * 获得本周的开始日期
 * @param format 返回的日期格式 默认yyyy-MM-dd
 * @return {*}
 */

export function getWeekStartDate(format) {
  var weekStartDate = new Date(this.nowYear(), this.nowMonth(), this.nowDay() - this.nowDayOfWeek());
  return this.formatDate(weekStartDate, format);
}
;
/**
 * 获得本周的结束日期
 * @param format 返回的日期格式 默认yyyy-MM-dd
 * @return {*}
 */

export function getWeekEndDate(format) {
  var weekEndDate = new Date(this.nowYear(), this.nowMonth(), this.nowDay() + (6 - this.nowDayOfWeek()));
  return this.formatDate(weekEndDate, format);
}
;
/**
 * 获得本月的开始日期
 * @param format 返回的日期格式 默认yyyy-MM-dd
 * @return {*}
 */

export function getMonthStartDate(format) {
  var monthStartDate = new Date(this.nowYear(), this.nowMonth(), 1);
  return this.formatDate(monthStartDate, format);
}
;
/**
 * 获得本月的结束日期
 * @param format 返回的日期格式 默认yyyy-MM-dd
 * @return {*}
 */

export function getMonthEndDate(format) {
  var monthEndDate = new Date(this.nowYear(), this.nowMonth(), this.getMonthDays(this.nowMonth()));
  return this.formatDate(monthEndDate, format);
}
;
/**
 * 获得 本年 的开始日期
 * @param format 返回的日期格式 默认yyyy-MM-dd
 * @return {*}
 */

export function getYearStartDate(format) {
  var monthStartDate = new Date(this.nowYear(), 0, 1);
  return this.formatDate(monthStartDate, format);
}
;
/**
 * 获得 本年 的结束日期
 * @param format 返回的日期格式 默认yyyy-MM-dd
 * @return {*}
 */

export function getYearEndDate(format) {
  var monthEndDate = new Date(this.nowYear(), 11, this.getMonthDays(11));
  return this.formatDate(monthEndDate, format);
}
;
/**
 * 获得上月开始时间
 * @param format 返回的日期格式 默认yyyy-MM-dd
 * @return {*}
 */

export function getLastMonthStartDate(format) {
  var lastMonthStartDate = new Date(this.nowYear(), this.preMonth(), 1);
  return this.formatDate(lastMonthStartDate, format);
}
;
/**
 * 获得上月结束时间
 * @param format 返回的日期格式 默认yyyy-MM-dd
 * @return {*}
 */

export function getLastMonthEndDate(format) {
  var lastMonthEndDate = new Date(this.nowYear(), this.preMonth(), this.getMonthDays(this.preMonth()));
  return this.formatDate(lastMonthEndDate, format);
}
;
/**
 * 获得本季度的开始日期
 * @param format 返回的日期格式 默认yyyy-MM-dd
 * @return {*}
 */

export function getQuarterStartDate(format) {
  var quarterStartDate = new Date(this.nowYear(), this.getQuarterStartMonth(), 1);
  return this.formatDate(quarterStartDate, format);
}
;
/**
 * 获得本季度的结束日期
 * @param format 返回的日期格式 默认yyyy-MM-dd
 * @return {*}
 */

export function getQuarterEndDate(format) {
  var quarterEndMonth = this.getQuarterStartMonth() + 2;
  var quarterStartDate = new Date(this.nowYear(), quarterEndMonth, this.getMonthDays(quarterEndMonth));
  return this.formatDate(quarterStartDate, format);
}
;
/**
 *  比较日期大小
 * @param date1 比较日期
 * @param date2 被比较日期
 * @param isWithEqual 是否可以等于
 * @param isWithTime 是否包含详细时间
 * @return date1是否大于date2
 */

export function dateComparison(date1, date2, isWithEqual, isWithTime) {
  if (date1 && !date2) {
    return true;
  }

  if (!date1) {
    return false;
  }

  if (date1 && date2) {
    var format = "yyyy-MM-dd";

    if (isWithTime) {
      format += " hh:mm:ss";
    }

    var formatDate1 = this.formatDate(date1, format);
    var formatDate2 = this.formatDate(date2, format);

    if (isWithEqual) {
      return formatDate1 >= formatDate2;
    } else {
      return formatDate1 > formatDate2;
    }
  }
}
;
/**
 * 获取本月的所有日期，返回是数组
 * @returns {[]}
 */

export function createMonthDay() {
  var daysOfMonth = [];
  var fullYear = new Date().getFullYear();
  var month = new Date().getMonth() + 1;
  var lastDayOfMonth = new Date(fullYear, month, 0).getDate();

  for (var i = 1; i <= lastDayOfMonth; i++) {
    daysOfMonth.push(fullYear + '-' + month + '-' + i);
  }

  ;
  return daysOfMonth;
}
;
/**
 * 获取某月的所有日期，返回是数组
 * @returns {[]}
 */

export function createMonthDate(value) {
  var daysOfMonth = [];
  var d = new Date(value);
  var fullYear = d.getFullYear();
  var month = d.getMonth() + 1;
  var lastDayOfMonth = new Date(fullYear, month, 0).getDate();

  for (var i = 1; i <= lastDayOfMonth; i++) {
    daysOfMonth.push(fullYear + '-' + month + '-' + i);
  }

  ;
  return daysOfMonth;
}
/**
 * 增加月份
 * @param value
 * @returns {string}
 */

export function addMonth(value) {
  var currentDate = new Date(value);
  var lastDate = currentDate.setMonth(currentDate.getMonth() + 1);
  lastDate = new Date(lastDate);
  var lastYear = lastDate.getFullYear();
  var lastMonth = checkMonth(lastDate.getMonth() + 1);
  lastDate = lastYear + '-' + lastMonth;
  return lastDate;
}
/**
 * 减少月份
 * @param value
 * @returns {string}
 */

export function subMonth(value) {
  var currentDate = new Date(value);
  var lastDate = currentDate.setMonth(currentDate.getMonth() - 1);
  lastDate = new Date(lastDate);
  var lastYear = lastDate.getFullYear();
  var lastMonth = checkMonth(lastDate.getMonth() + 1);
  lastDate = lastYear + '-' + lastMonth;
  return lastDate;
}
/**
 * 获取当前月份yyyy-MM
 * @param value
 * @returns {string}
 */

export function curMonth(value) {
  var currentDate = new Date(value);
  var lastDate = currentDate.getMonth();
  lastDate = new Date(lastDate);
  var lastYear = currentDate.getFullYear();
  var lastMonth = checkMonth(lastDate.getMonth() + 1);
  lastDate = lastYear + '-' + lastMonth;
  return lastDate;
}
/**
 * 拼接月份
 * @param i
 * @returns {string}
 */

export function checkMonth(i) {
  if (i < 10) {
    i = "0" + i;
  }

  return i;
}